import React, { useState } from "react";
import { FaPlus, FaTimes } from "react-icons/fa";
import "./FaqSection.css"; // We'll put the custom styles here

const faqData = [
{
  id: "01",
  question: "How do I begin my journey to study abroad?",
  answer:
    "You can start by creating a free profile with us and sharing details about your education, preferred countries, and courses. Once registered, our expert counselors will review your profile and help you shortlist universities, prepare applications, and plan the next steps smoothly.",
},
{
  id: "02",
  question: "Do you provide support for exams like GRE, TOEFL, IELTS, or PTE?",
  answer:
    "Yes! We offer guidance, study resources, and training support for major exams like GRE, GMAT TOEFL, IELTS, and PTE. Our team helps you with test strategies, preparation tips, and scheduling your exam at the right time.",
},
{
  id: "03",
  question: "Can you help me with scholarships and financial aid?",
  answer:
    "Absolutely. We assist students in identifying scholarship opportunities, education loans, and financial aid options offered by universities and funding bodies to reduce the overall cost of studying abroad.",
},
{
  id: "04",
  question: "What exams do I need to take for admission to universities abroad?",
  answer:
    "The required exams vary by country and program. Common tests include IELTS, TOEFL, GRE, or GMAT. We guide you in choosing and preparing for the right exams based on your study goals.",
},
{
  id: "05",
  question: "Is counseling or University application support free?",
  answer:
    "Basic counseling, profile evaluation, and University shortlisting are free. However, specialized services such as premium application packages, fast-track admission processing, or exclusive placement guidance may come with a fee.",
}

  
];

export default function FaqSection() {
  const [activeIndex, setActiveIndex] = useState(); // Open item 04 by default

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="container py-5">
      <h2 className="mb-5 fw-bold heading">Frequently asked Questions</h2>
      <div className="row g-3">
        {faqData.map((faq, index) => (
          <div className="col-md-6" key={index}>
            <div
              className={`faq-card p-3 d-flex align-items-center ${
                activeIndex === index ? "active" : ""
              }`}
              onClick={() => toggleFaq(index)}
            >
              <div className="faq-number me-3">{faq.id}</div>
              <div className="flex-grow-1">
                <div className="d-flex justify-content-between align-items-start">
                  <h4 className="mb-0 fw-semibold">{faq.question}</h4>
                  <span className="faq-icon">
                    {activeIndex === index ? <FaTimes /> : <FaPlus />}
                  </span>
                </div>
                {activeIndex === index && faq.answer && (
                  <p className="mt-2">{faq.answer}</p>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
